import _, { get } from 'lodash'
import modalConversion from './modalConversion.html'
import modalClone from './modalClone.html'
import modalChangeAction from './modalChangeAction.html'
import { MachinesMainGridConfig } from '../Pages/Main/Grid/config'

function getModalChangeAction(result) {
  return {
    templateUrl: modalChangeAction,
    controller: ['$scope', '$uibModalInstance', '$window', 'reportingServer', function ($scope, $uibModalInstance, $window, reportingServer) {
      $scope.ModalData = result
      $scope.selectedReportFlags = []

      reportingServer.getReportGroup('machine').then(reportGroup => {
        $scope.reportGroup = reportGroup
      })

      // reportingUtils
      //   .GetReports()
      //   .then(reportGroup => {
      //     $scope.availableReports = reportGroup.Reports
      //   })
      $scope.ModalOk = function () {
        $uibModalInstance.close()
      }
      $scope.reportSubmit = function (result) {
        $scope.httpPending = true
        const selectedMachineConfigurationIds = result.MachineConfigurations.map(config => config.Id)
        const selectedReportIds = Object.entries($scope.reportGroup.Reports)
          .filter((_, index) => $scope.selectedReportFlags[index])
          .map(entry => {
            return entry[0]
          })

        // const selectedReportIds = _.chain(_.range(Object.entries($scope.availableReports).length))
        //   .filter(index => $scope.selectedReportFlags[index])
        //   .map(index => $scope.availableReports[index].JsReportId)
        //   .value()
        reportingServer.renderReportBatch({
          reports: selectedReportIds,
          ids: selectedMachineConfigurationIds,
          batchUrl: $scope.reportGroup.BatchUrl
        })
          .then(zipFile => {
            const blobUrl = $window.URL.createObjectURL(zipFile)
            const downloadLink = angular.element('<a></a>')
            downloadLink.attr('href', blobUrl)
            downloadLink.attr('download', 'reports.zip')
            downloadLink[0].click()
            if ($uibModalInstance) {
              $uibModalInstance.close(selectedReportIds)
            }
          })
          .catch(error => {
            const errorMessage = get(error, 'message') || 'Unknown error ocurred.  Please try again'
            console.log(errorMessage)
          })
          .finally(() => {
            this.showSpinner = this.cancelDisabled = this.submitDisabled = false
          })

      }
      $scope.ModalCancel = function () {
        $uibModalInstance.dismiss('cancel')
      }
    }]
  }
}

function getModalConversion(machine) {

  return {
    templateUrl: modalConversion,
    controller: ['$state', '$scope', '$uibModalInstance', function ($state, $scope, $uibModalInstance) {

      $scope.chosenConvetion = {}
      $scope.disableConversion = true

      $scope.ModalCancel = function () {
        $uibModalInstance.dismiss('cancel')
        $scope.chosenConvetion = null
      }

      $scope.ShowFormForNewConversion = function () {
        $state.go('main.machines.machine.configure', { machineId: machine.MachineId, machineConfigure: machine })

        $uibModalInstance.close()
      }

      $scope.ExpandModalWindow = function () {
        var modalWindow = angular.element(document.querySelector('.modal-content'))
        modalWindow.css("width", "950px")
      }

      $scope.ModalApply = function () {
        if (!$scope.chosenConvetion.Id) {
          alert('Conversion was not selected')
        }
        else {
          $uibModalInstance.close()

          $state.go(
            'main.machines.machine.configure',
            { machineId: machine.MachineId, machineConfigure: $scope.chosenConvetion }
          )
        }
      }
    }],
    controllerAs: 'ctrl',
    bindToController: true
  }
}

function getModalClone(machineConfigurations, selectedConfiguration) {
  return {
    templateUrl: modalClone,
    controller: ['$state', '$scope', '$uibModalInstance', function ($state, $scope, $uibModalInstance) {
      $scope.machineConfigurations = machineConfigurations
      $scope.selectedConfiguration = _.find(machineConfigurations, mc => mc.MachineConfigurationId === selectedConfiguration.MachineConfigurationId)

      $scope.ModalCancel = function () {
        $uibModalInstance.dismiss('cancel')
        $scope.chosenConvetion = null
      }

      $scope.ExpandModalWindow = function () {
        var modalWindow = angular.element(document.querySelector('.modal-content'))
        modalWindow.css("width", "950px")
      }

      $scope.ModalApply = function () {
        const selectedConfiguration = MachinesMainGridConfig.getCloneConfiguration($scope.selectedConfiguration)
        $uibModalInstance.close()
        $state.go('main.machines.add', { machine: selectedConfiguration })
      }
    }],
    controllerAs: 'ctrl',
    bindToController: true
  }
}

export default {
  modalChangeAction: getModalChangeAction,
  modalConversion: getModalConversion,
  modalClone: getModalClone
}
